import { createApp } from 'vue'
import App from './App.vue'

function createBaiduMap(element) {
  const app = createApp(App, {
    ...element.dataset
  })
  app.mount(element)
}

export default function init() {
  const elements = document.querySelectorAll('.BaiduMaps')
  elements.forEach((element) => {
    if (!element.__vue_app__) {
      createBaiduMap(element)
    }
  })

  window.initBaiduMapsInContentTabs = () => {
    const containers = document.querySelectorAll('.ContentTabs__container')
    containers.forEach((container) => {
      const maps = container.querySelectorAll('.BaiduMaps')
      maps.forEach((map) => {
        if (!map.__vue_app__) {
          createBaiduMap(map)
        }
      })
    })
  }
}
